/// <amd-module name="VSS/Platform/Util/Linking" />

export interface IArtifactData {
    uri?: string;
    tool: string;
    type: string;
    id: string;
}

const VSTFS = "vstfs:///";
const URI_SEPARATOR = "/";

/**
 * Creates an artifact URI using specified artifact.
 *
 * @param artifact Artifact to encode
 * @return uri representation of the artifact.
 */
export function encodeUri(artifact: IArtifactData): string {
    return VSTFS + [encodeURIComponent(artifact.tool), encodeURIComponent(artifact.type), encodeURIComponent(artifact.id)].join(URI_SEPARATOR);
}

/**
 * Decodes the specified artifact URI and creates artifact object which has tool, type and id properties.
 *
 * @param artifactUri URI to decode
 * @return decoded artifact.
 */
export function decodeUri(artifactUri: string): IArtifactData {
    let vstfs: string;
    let parts: string[];

    if (artifactUri.length > VSTFS.length) {
        vstfs = artifactUri.substr(0, VSTFS.length).toLowerCase();
        if (vstfs === VSTFS) {
            parts = artifactUri.substr(VSTFS.length).split(URI_SEPARATOR);
            if (parts.length >= 3) {
                const tool = parts[0];
                const type = parts[1];
                const id = parts.slice(2).join("/");
                return {
                    uri: artifactUri,

                    // IMPORTANT! Not using decodeURIComponent directly here is by design to keep backwards compatibility
                    // and symmetry with encoding of artifact URIs from the rich client and VS2010 and earlier clients.
                    tool: legacyDecodeURIComponent(tool),
                    type: legacyDecodeURIComponent(type),
                    id: legacyDecodeURIComponent(id)
                };
            }
        }
    }

    throw new Error(`Invalid artifact uri: ${artifactUri}`);
}

/**
 * Decodes a uri component, maintaining backwards compatibility with how URIs were encoded
 * from the rich client and in VS2010 and earlier versions.
 *
 * @param encodedURIComponent URI component to decode
 * @return decoded component
 */
function legacyDecodeURIComponent(encodedURIComponent: string): string {
    let result: string;

    // special case handling of the encoded '+' sign (denotes a space), use regex with /g to replace all occurrences
    result = encodedURIComponent.replace(/\+/g, " ");
    result = decodeURIComponent(result);

    return result;
}
